export default class MouseEvents {
    private el: HTMLCanvasElement;
    private clickHandler: (e: MouseEvent) => void;
    private doubleclickHandler: (e: MouseEvent) => void;
    private dragHandler: (e: MouseEvent) => void;
    private dragMoveHandler: (e: MouseEvent) => void;
    private dropHandler: (e: MouseEvent) => void;
    private hoverHandler?: (e: MouseEvent) => void = null;

    private mouseDownEvent: MouseEvent;
    private couldStartDragging = false;
    private isDragging: boolean = false;
    private clickTimeout: number;

    private contextedHandlers = {
        mouseMove: (e) => this.onMouseMove(e),
        mouseDown: (e) => this.onMouseDown(e),
        mouseUp: (e) => this.onMouseUp(e)
    }
    constructor(
        el: HTMLCanvasElement,
        clickHandler: (e: MouseEvent) => void,
        doubleclickHandler: (e: MouseEvent) => void,
        dragHandler: (e: MouseEvent) => void,
        dragMoveHandler: (e: MouseEvent) => void,
        dropHandler: (e: MouseEvent) => void
    ) {
        this.el = el;
        el.addEventListener('mousedown', this.contextedHandlers.mouseDown, false);
        el.addEventListener('mouseup', this.contextedHandlers.mouseUp, false);
        el.addEventListener('mouseleave', this.contextedHandlers.mouseUp, false);
        el.addEventListener('mousemove', this.contextedHandlers.mouseMove, false);

        this.clickHandler = clickHandler;
        this.doubleclickHandler = doubleclickHandler;
        this.dragHandler = dragHandler;
        this.dragMoveHandler = dragMoveHandler;
        this.dropHandler = dropHandler;
    }

    public onHover(handler: (e: MouseEvent) => void) {
        if (this.hoverHandler) { throw "HoverHandler already set"; }
        this.hoverHandler = handler;
    }

    destruct() {
        this.el.removeEventListener('mousedown', this.contextedHandlers.mouseDown, false);
        this.el.removeEventListener('mouseup', this.contextedHandlers.mouseUp, false);
        this.el.removeEventListener('mouseleave', this.contextedHandlers.mouseUp, false);
        this.el.removeEventListener('mousemove', this.contextedHandlers.mouseMove, false);
        this.clickHandler = this.doubleclickHandler = this.dragHandler = this.dragMoveHandler = this.dropHandler = this.hoverHandler = null;
    }
    private onMouseMove(e: MouseEvent) {
        if (this.hoverHandler) {
            this.hoverHandler(e);
        }
        if (this.couldStartDragging) {
            if (!this.isDragging) {
                if (e.offsetX == this.mouseDownEvent.offsetX
                    && e.offsetY == this.mouseDownEvent.offsetY) {
                    return;
                }
                this.dragHandler(this.mouseDownEvent);
                this.isDragging = true;
            }
            this.dragMoveHandler(e);
        }
    }
    private onMouseDown(e: MouseEvent) {
        this.mouseDownEvent = e;
        this.isDragging = false;
        this.couldStartDragging = true;
    }
    private onMouseUp(e: MouseEvent) {
        this.couldStartDragging = false;

        if (this.isDragging) {
            this.dropHandler(e);
        } else if (this.clickTimeout) {
            window.clearTimeout(this.clickTimeout);
            this.clickTimeout = null;
            this.doubleclickHandler(e);
        } else {
            this.clickTimeout = window.setTimeout(() => {
                this.clickHandler(e);
                this.clickTimeout = null;
            }, 200);
        }
    }
}